import React from 'react'
import star from '../images/star.png'
import Image from '../images/2.jpg'

function section2() {
    return (
        <>
            <div className=" slider py-5">

                <h1>Testimonials</h1>
                <div id="carouselExampleIndicators" className="carousel slide">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className='images' src={require('../images/0.jpg')} alt={"..."} />
                            <span>Farouk El-Nemr</span>
                            <div>
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                            </div>
                            <p>The food tastes great and the delivery is very fast.</p>
                            
                        </div>
                        <div className="carousel-item">
                            <img className='images' src={Image} alt={"..."} />
                            <span>Saif Shaker</span>
                            <div>
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                            </div>
                            <p>The food is indescribably delicious, Thank you very much.</p>
                        </div>
                        <div className="carousel-item">
                            <img className='images' src={require('../images/1.jpg')} alt={"..."} />
                            <span>Hayat Akram</span>
                            <div>
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                                <img className='rate' src={star} alt="Rate" />
                            </div>
                            <p>One of the best places that serve great food.</p>
                            
                        </div>
                    </div>

                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={1} aria-label="Slide 2" />
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={2} aria-label="Slide 3" />
                    </div>

                </div>
                
            </div>

        </>

    )
}

export default section2